/* eslint-disable no-shadow */

/**
 * Типы преходов
 *
 * @export
 * @enum {string}
 */
export const enum TransitionType {
  approve = 'approve',
  revision = 'revision',
  fallback = 'fallback',
}

/**
 * Типы маршрутизации параллельных маршрутов
 *
 * @export
 * @enum {number}
 */
export const enum RoutingType {
  single = 'single',
  parallel = 'parallel',
}
